import React, { Component } from "react";
import "./index.css";
export default class Footer extends Component {
  render() {
    return (
      <div class="footer">
        <div className="brand-grid">
          <img
            src={require("../../assets/marconi.png")}
            style={{ height: "100px" }}
          ></img>
          <img
            src={require("../../assets/celestini.png")}
            style={{ height: "100px" }}
          ></img>
          <img
            src={require("../../assets/iitd.9d8b4d82.png")}
            style={{ height: "100px" }}
          ></img>
        </div>
        <div class="footer-links-grid">
          <div>
            <h2>Report Bug</h2>
            <ul>
              <li>
                <a href="mailto:dataset.emospeech@gmail.com">Contact Us</a>
              </li>
            </ul>
          </div>
          <div>
            <h2>Know More</h2>
            <ul>
            <li>
                <a href="https://play.google.com/store/apps/details?id=com.scibots.rakshak">Rakshak App</a>
              </li>
            <li>
                <a href="https://quickspeech-in.web.app">QuickSpeech</a>
              </li>
              <li>
                <a href="https://arxiv.org/abs/1910.13801">arXiv</a>
              </li>
              <li>
                <a href="https://www.celestiniprojectindia.com/">
                  Celestini Project India
                </a>
              </li>
              <li>
                <a href="http://marconisociety.org/">Marconi Society</a>
              </li>
              <li>
                <a href="http://www.iitd.ac.in/">IIT Delhi</a>
              </li>
            </ul>
          </div>
        </div>

        <div class="footer-copyright">© RAKSHAK TEAM 2019</div>
      </div>
    );
  }
}
